import { GpsInfo } from "@models/Map/gpsInfo.model";

export interface SvMetadataInfo {
    id: number;
    captureDate: Date;
    expireDate: Date;
    modifiedDate: Date;

    sourceId: string;
    sourceName: string;
    tags: string[];
    //cameraType: CameraType.LinePower;
    //cameraModel: string;
    cameraId: number;
    thumbnailType: string;

    fileName: string;
    fileSize: number;
    imageDimensions: string;
    comments: string;
    captureMethod: ImageCaptureMethod;

    gpsLocation: GpsInfo;
    svPipelineSequence: number[];
    svPipelineCompletedDate: Date;
    svPipelineResults: SvPipelineResult[];

    //userName: string;
    //userGroupId: number;

    pipelineInfo: string;
    pipelineResults?: ScoutviewPipelineResultsInfo;
}

export interface ScoutviewPipelineResultsInfo {
    details?: { [key: string] : string }
    overallResults: string;
    finishedSuccessfully: boolean;
}

export interface GatewayImageStatsInfo {
    sourceId: string;
    totalCount: number;
    rangeCount: number;
    expiringIn3Days: number;
    expiringIn3Weeks: number;
    expiringIn3Months: number;
}

export interface SvPipelineInfo {
    pipelineName: string;
    processStepNames: string[];
}

export interface SvPipeline {
    id: number;
    name: string;
    type: ImageProcessingType;
    options: string;
}

export interface SvPipelineResult {
    id: number;
    svMetadataId: number;
    svPipelineId: number;
    results: string;
    completedDate: Date;
}

export interface PtzControlResults {
    status: string;
    focus: number;
    zoom: number;
    gatewayIP: string;
}

export enum ImageProcessingType {
    internalMethod = 0,
    internalUrl = 1,
    externalUrl = 2,
}

export enum CameraType {
    LinePower = 0,
    SolarPower = 1
}

export enum ImageCaptureMethod {
    Manual = 0,
    Timer = 1,
    Sensor = 2,
    Motion = 3
}

export enum MetaDataUpdateOption {
    New = 0,
    Update = 1
}